import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WeakAreaAlert = ({ areas }) => {
  const navigate = useNavigate();

  if (!areas || areas?.length === 0) {
    return null;
  }

  const handlePracticeClick = (area) => {
    navigate(`/question-practice?mode=knowledge-area&area=${encodeURIComponent(area)}`);
  };

  return (
    <div className="bg-warning/10 border border-warning/30 rounded-xl p-4 md:p-6">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-warning/20 flex items-center justify-center flex-shrink-0">
          <Icon name="AlertTriangle" size={20} className="text-warning" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">
            Areas Needing Attention
          </h3>
          <p className="text-sm text-muted-foreground">
            Focus on these knowledge areas to improve your overall score
          </p>
        </div>
      </div>
      <div className="space-y-3">
        {areas?.map((area, index) => (
          <div 
            key={index}
            className="flex items-center justify-between p-3 bg-card rounded-lg border border-border"
          >
            <div className="flex-1 min-w-0 mr-3">
              <h4 className="text-sm font-medium text-foreground mb-1 line-clamp-1">
                {area?.name}
              </h4>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <span className="data-text">Current: {area?.score}%</span>
                <span className="w-1 h-1 rounded-full bg-muted-foreground" />
                <span className="data-text">Target: {area?.target}%</span>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => handlePracticeClick(area?.name)}
              iconName="ArrowRight"
              iconPosition="right"
            >
              Practice
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeakAreaAlert;